import { Outlet, RouteObject } from "react-router-dom";
import MenuLayout from "../MenuLayout";
import SessionBoundary from "../SessionBoundary";
import ValidateUUID from "../ValidateUUID";
import AccountsReportScreen from "./AccountsReportScreen";
import CallRatingsReportScreen from "./CallRatingsReportScreen";
import CreateFacilityScreen from "./CreateFacilityScreen";
import CreateSystemScreen from "./CreateSystemScreen";
import DebugCallsScreen from "./debug/DebugCallsScreen";
import OrganizationScreen from "./OrganizationScreen";
import OrganizationsScreen from "./OrganizationsScreen";
import ReportsScreen from "./ReportsScreen";
import StaffManagementScreen from "./StaffManagementScreen.tsx";
import SystemSatisfactionReportScreen from "./SystemSatisfactionReportScreen";
import SystemScreen from "./SystemScreen";
import SystemsScreen from "./SystemsScreen";
import UpdateSystemScreen from "./UpdateSystemScreen.tsx";
import VisitorScreen from "./VisitorScreen";
import VisitorsScreen from "./VisitorsScreen";

const ToolboxChildren: RouteObject[] = [
  {
    index: true,
    element: <MenuLayout currentTab="none" />,
  },
  {
    path: "systems",
    element: (
      <MenuLayout currentTab="systems-tools">
        <SystemsScreen />
      </MenuLayout>
    ),
  },
  {
    path: "systems/new",
    element: (
      <MenuLayout currentTab="systems-tools">
        <CreateSystemScreen />
      </MenuLayout>
    ),
  },
  {
    path: "debug/calls",
    element: (
      <MenuLayout currentTab="debug-calls">
        <DebugCallsScreen />
      </MenuLayout>
    ),
  },
  {
    path: "systems/:systemId",
    element: (
      <MenuLayout currentTab="systems-tools">
        <ValidateUUID id="systemId">
          <SystemScreen />
        </ValidateUUID>
      </MenuLayout>
    ),
  },
  {
    path: "systems/:systemId/edit",
    element: (
      <MenuLayout currentTab="systems-tools">
        <ValidateUUID id="systemId">
          <UpdateSystemScreen />
        </ValidateUUID>
      </MenuLayout>
    ),
  },
  {
    path: "systems/:systemId/facilities/new",
    element: (
      <MenuLayout currentTab="systems-tools">
        <ValidateUUID id="systemId">
          <CreateFacilityScreen />
        </ValidateUUID>
      </MenuLayout>
    ),
  },
  {
    path: "organizations",
    element: (
      <MenuLayout currentTab="organizations-tools">
        <OrganizationsScreen />
      </MenuLayout>
    ),
  },
  {
    path: "kratos",
    element: (
      <MenuLayout currentTab="kratos">
        <StaffManagementScreen />
      </MenuLayout>
    ),
  },
  {
    path: "organizations/:id",
    element: (
      <MenuLayout currentTab="organizations-tools">
        <ValidateUUID id="id">
          <OrganizationScreen />
        </ValidateUUID>
      </MenuLayout>
    ),
  },
  {
    path: "visitors",
    element: (
      <MenuLayout currentTab="visitors-tools">
        <VisitorsScreen />
      </MenuLayout>
    ),
  },
  {
    path: "visitors/:visitorId",
    element: (
      <MenuLayout currentTab="visitors-tools">
        <ValidateUUID id="visitorId">
          <VisitorScreen />
        </ValidateUUID>
      </MenuLayout>
    ),
  },
  {
    path: "reports",
    element: (
      <MenuLayout currentTab="reports-tools">
        <Outlet />
      </MenuLayout>
    ),
    children: [
      {
        index: true,
        element: <ReportsScreen />,
      },
      {
        path: "accounts",
        element: <AccountsReportScreen />,
      },
      {
        path: "call-ratings",
        element: <CallRatingsReportScreen />,
      },
      {
        path: "system-satisfaction",
        element: <SystemSatisfactionReportScreen />,
      },
    ],
  },
];

export const ToolboxRoutesOld = {
  path: "/toolbox",
  element: (
    <SessionBoundary userType="AmeelioStaff">
      <Outlet />
    </SessionBoundary>
  ),
  children: ToolboxChildren,
};

const ToolboxRoutes: RouteObject = {
  path: "/",
  element: (
    <SessionBoundary userType="AmeelioStaff">
      <Outlet />
    </SessionBoundary>
  ),
  children: ToolboxChildren,
};

export default ToolboxRoutes;
